import { Injectable, Injector } from '@angular/core';
import { EndpointFactory } from '../endpoint-factory.service';
import { IPlugInRequest } from 'src/app/models/plugin';
import { catchError, firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ConfigurationService } from '../configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class PluginEndpointService extends EndpointFactory {

  constructor(http: HttpClient, configurations: ConfigurationService, injector: Injector) {
    super(http, configurations, injector, '', configurations.webAppApiBaseUrl);
  }

  sendPluginRequest(request: IPlugInRequest): Promise<any> {
    const url = `${this.url}plugin/execute?action=${request.action}`;
    return firstValueFrom(this.http.post<any>(url, request).pipe(
        catchError(error => {
            return this.handleError(error);
        })));
  }
}
